/* HUSHLY — recherche et depliage du centre d'aide */
(function(){
  function init(root){
    (root||document).querySelectorAll('.hfaq').forEach(function(sec){
      if (sec.dataset.hfaqReady==='1') return;
      sec.dataset.hfaqReady='1';
      var input = sec.querySelector('#hfaq-q');
      var cats  = [].slice.call(sec.querySelectorAll('[data-hfaq-cat]'));
      var count = sec.querySelector('[data-hfaq-count]');
      var empty = sec.querySelector('[data-hfaq-empty]');

      sec.querySelectorAll('[data-hfaq-more]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var c = btn.closest('[data-hfaq-cat]');
          c.classList.toggle('is-open');
          btn.textContent = c.classList.contains('is-open') ? (btn.dataset.less||'See less') : (btn.dataset.more||'See More');
        });
        btn.dataset.more = btn.textContent;
      });

      if (!input) return;
      var norm = function(s){ return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,''); };
      input.addEventListener('input', function(){
        var q = norm(input.value.trim());
        var total = 0;
        cats.forEach(function(c){
          var visibles = 0;
          c.querySelectorAll('[data-hfaq-item]').forEach(function(it){
            var txt = norm(it.querySelector('[data-hfaq-question]').textContent + ' ' +
                           it.querySelector('[data-hfaq-answer]').textContent);
            var match = !q || txt.indexOf(q) > -1;
            it.hidden = !match;
            if (match) visibles++;
          });
          /* pendant une recherche on montre tout ce qui correspond */
          c.classList.toggle('is-open', !!q);
          c.hidden = visibles === 0;
          var b = c.querySelector('[data-hfaq-more]');
          if (b) b.hidden = !!q;
          total += visibles;
        });
        if (count){ count.hidden = !q; count.textContent = total + (total > 1 ? ' résultats' : ' résultat'); }
        if (empty) empty.hidden = !(q && total === 0);
      });
    });
  }
  if (document.readyState==='loading') addEventListener('DOMContentLoaded',function(){init()},{once:true});
  else init();
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
